import { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import { formatDate } from '../../Components/InputElements';
import axios from "axios";
class SalaryDetails extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            loadingList: false,
            postLoading: false,
            employee_info: [],
            salaries: [],
            salaries_statutory: [],

        };
    }

    componentDidMount() {
        this.setState({ loadingList: true }, () => {
            this.GetList();
        });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON, employee_id } = this.context;
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetProfile?employee_id=${employee_id}`, { headers })
            .then((response) => {
                var data = response.data.data;
                if (response.data.success === true) {
                    this.setState({
                        salaries: data.salary_head,
                        salaries_statutory: data.salary_statutory,
                        employee_info: data.employee,
                        loadingList: false,
                    });
                } else {
                    this.setState({ loadingList: false });
                }
            });
    };


    render() {
        const { salaries, employee_info, salaries_statutory } = this.state;
        return (
            this.state.loadingList === false ?
                (
                    <div class="main-content" >
                        <div class="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`Salary Details`} primary={`My details`} />
                                <div className='card'>
                                    <div className='card-body'>

                                        {/* <div class="card-header bg-light bg-gradient">
                                <h6 className="card-title mb-0 text-center" >SALARY DETAILS</h6>
                            </div> */}

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="card-body">
                                                    <div className="card-header">
                                                        <h6 className="card-title mb-0 text-center" >SALARY HEADS</h6>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-sm text-center table-hover table-nowrap" >
                                                            <thead className="bg-primary bg-gradient text-light">
                                                                <tr>
                                                                    <th scope="col">SALARY HEADS</th>
                                                                    <th scope="col">PER ANNUM</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {salaries.map((row) => (
                                                                    <tr key={row.employee_salary_head_id}>
                                                                        <td>{row.company_salary_head}</td>
                                                                        <td>{row.amount}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot className='bg-primary bg-gradient text-light'>

                                                                <tr>
                                                                    <th>Gross</th>
                                                                    <th>{employee_info.gross}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="card-body">
                                                    <div className="card-header">
                                                        <h6 className="card-title mb-0 text-center" >SALARY STATUTORY HEADS</h6>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-sm text-center table-hover table-nowrap">
                                                            <thead className="bg-primary bg-gradient text-light">
                                                                <tr>
                                                                    <th scope="col">SALARY STATUTORY HEADS</th>
                                                                    {/* <th scope="col">CALCULATED AMOUNT</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {salaries_statutory.map((row) => (
                                                                    <tr key={row.employee_salary_statutory_id}>
                                                                        <td>{row.company_salary_statutory_title}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot className='bg-primary bg-gradient text-light'>
                                                                <tr>
                                                                    {/* <th>CTC</th> */}
                                                                    <th>CTC {employee_info.cts}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default SalaryDetails;